import React from 'react';
import common from 'constants/common';
import { isNotUndefined } from 'infrastructure/functions';
import BaseTag from 'components/atoms/base-tag';

import s from './styles.module.scss';

import type { CcmStatuses } from 'infrastructure/enums';

interface IProps {
  ccmStatus: CcmStatuses;
}

const CcmStatus: React.FC<IProps> = ({ ccmStatus }) => {
  const status = isNotUndefined(ccmStatus)
    ? common.ccmStatus[ccmStatus]
    : undefined;

  return (
    <BaseTag
      className={s.tag}
      data-cy="patientTable-ccmStatus"
      size="large"
      color={status?.color}
      label={status?.label}
    />
  );
};

export default CcmStatus;
